import type { ChangeEventHandler, InputHTMLAttributes } from 'react';
import type { Path, UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { ISearchBarFormValues } from '~/components/SearchBar';
import styles from './styles';

type ISearchBarProps = {
  name: Path<ISearchBarFormValues>;
  onChange: ChangeEventHandler<HTMLInputElement>;
  register: UseFormRegister<ISearchBarFormValues>;
  tabIndex?: number;
} & InputHTMLAttributes<HTMLInputElement>;

const SearchBarInput = ({ name, onChange, register, tabIndex }: ISearchBarProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <input
      {...register(name)}
      css={[styles.input]}
      placeholder={t('searchNavLandingScreen.overview.searchInput.placeholder')}
      tabIndex={tabIndex}
      type="text"
      autoComplete="off"
      onChange={onChange}
    />
  );
};

export default SearchBarInput;
